import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            资源分类导航
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            按类别快速浏览，精准定位您想要的资源类型
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop>
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              className="group relative overflow-hidden rounded-xl bg-background-100 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={`鬼父在线 - ${category.name}`}
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-7 h-7 flex items-center justify-center rounded-md bg-primary-500/90">
                    <i className={`${category.icon} text-sm text-white`}></i>
                  </div>
                  <h3 className="text-lg font-heading font-bold text-white">
                    {category.name}
                  </h3>
                </div>
                <p className="text-xs text-white/70 mt-1 line-clamp-1">
                  {category.description}
                </p>
                <span className="inline-block mt-2 text-xs text-primary-300 bg-black/30 px-2 py-0.5 rounded-full">
                  {category.count.toLocaleString()} 部资源
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}